module.exports = __webpack_public_path__ + "static/ritorno-by-night-f56a1db7493515bcb17b3e5b1ddcea2b.jpg";